var _style, _path, _path2, _circle, _g, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0052B4;}\n\t.st1{fill:#6DA544;}\n\t.st2{fill:#FFDA44;}\n\t.st3{fill:#F0F0F0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437,437C337,537,175,537,75,437S-25,175,75,75c7.9,7.9,204.6,157.4,204.6,157.4L437,437z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,75C175-25,337-25,437,75s100,262.1,0,362"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 256,
    cy: 256,
    r: 66.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.3,367.3l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1l-15.9,3.6l0,16.3l-12.7-10.2L82.6,423l0-16.3l-15.9-3.6 L79.5,393l-7.1-14.7l15.9,3.7L95.3,367.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.4,244.9l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1L62,284.2l0,16.3l-12.7-10.2l-12.7,10.2l0-16.3l-15.9-3.6 l12.8-10.1l-7.1-14.7l15.9,3.7L49.4,244.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.3,144.7l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1l-15.9,3.6l0,16.3l-12.7-10.2l-12.7,10.2l0-16.3l-15.9-3.6 l12.8-10.1l-7.1-14.7l15.9,3.7L95.3,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M152.4,222.6l7,14.7l15.9-3.7l-7.1,14.7l12.8,10.1l-15.9,3.6l0,16.3l-12.7-10.2l-12.7,10.2l0-16.3l-15.9-3.6 l12.8-10.1l-7.1-14.7l15.9,3.7L152.4,222.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.6,289.4l5.5,17H135l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L111.6,289.4z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,300.5h22.3c0,0,9.6-17.1,0-33.4l22.3-22.3l-11.1-22.3h-11.1c0,0-5.6,16.7-27.8,16.7s-27.8-16.7-27.8-16.7 h-11.1l11.1,22.3l-11.1,22.3l11.1,11.1c0,0,11.1-22.3,33.4-11.1C256,267.1,265.5,281,256,300.5L256,300.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M422.2,140.2c0.5-2.7,0.8-5.6,0.8-8.4c0-19.8-12.9-36.6-30.8-42.4c5.5,11.1,8.5,23.6,8.5,36.8 c0,4.5-0.4,8.8-1,13.1c-2.7-4.3-6.1-8.3-10.4-11.7c-15.9-12.7-37.6-13-53.7-2.3c12.4,2.7,24.4,8.2,35,16.7 c8.3,6.6,15,15.5,20.2,24.2l-68,21.3c66.8,11.1,122.4-33.4,122.4-33.4C439.1,141.7,429.5,139.6,422.2,140.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCx);
export default __webpack_public_path__ + "static/media/cx.2ea85b37b4eff396e4984d374d2cd8b2.svg";
export { ForwardRef as ReactComponent };